import {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo
} from "react";
import _axios from "../axios";
import WidgetsLoop from "../components/WidgetsLoop";
import WidgetsLoopMobile from "../components/WidgetsLoopMobile";
import SingleProducts from "../components/SingleProduct";
import buildLink from "../urls";
import PointsLoader from "../components/PointsLoader";

function Home() {
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [widgets, setWidgets] = useState([]);
  const [products, setProducts] = useState([]);
  const observer = useRef(null);
  const dataRef = useRef([]);
  const productRef = useRef([]);

  const lastElementRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (page === 1) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (page > 1) {
      fetchData();
    }
  }, [page]);

  const fetchData = async () => {
    if (isLoading) return;

    setIsLoading(true);
    const obj = {
      view: window.innerWidth > 650 ? "web_desktop" : "web_mobile",
      limit: 10,
      page: page,
    };

    try {
      const response = await _axios.post(
        buildLink("home", undefined, window.innerWidth),
        obj
      );

      if (response?.data?.success) {
        let newData = response?.data?.data?.widgets || [];

        if (response?.data?.data?.meta?.type === "No_widgets") {
          newData = response?.data?.data?.widgets?.items || [];
          productRef.current = [...productRef.current, ...newData];
          setProducts((prev) => [...prev, ...newData]);
        } else {
          dataRef.current = [...dataRef.current, ...newData];
          setWidgets((prev) => [...prev, ...newData]);
        }

        setHasMore(newData.length > 0);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
  };

  const WidgetsList = useMemo(
    () =>
      widgets.map((widget, index) => (
        <div
          key={widget.mobile_widget_id || widget.widget_id || index}
          ref={index === widgets.length - 1 && products.length === 0 ? lastElementRef : null}
          className="theHome"
        >
          {window.innerWidth < 650 ? (
            <WidgetsLoopMobile widget={widget} ishome={false} />
          ) : (
            <WidgetsLoop widget={widget} ishome={false} />
          )}
        </div>
      )),
    [widgets, lastElementRef, products.length]
  );

  const ProductsList = useMemo(
    () =>
      products.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-4 max-sm:grid-cols-3 max-[450px]:grid-cols-2 max-xs:grid-cols-2 max-md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 p-2 gap-2 mt-1 mb-1  md:grid-cols-5 max-lg:grid-cols-5">
          {products.map((item, index) => (
            <div 
              key={item.product_id || index} 
              className="p-3"
              ref={index === products.length - 1 ? lastElementRef : null}
            >
              <SingleProducts
                item={item}
                isWidget={true}
                sort_order={index + 1}
              />
            </div> 
          ))}
        </div>
      ),
    [products, lastElementRef]
  );

  return (
    <div>
      {/* {window.innerWidth < 650 &&
        window.config["site-url"] === "https://www.englishhome.com.lb" && (
          <img
            style={{ marginTop: "-1px" }}
            src={download}
            alt="download-app"
            className="cursor-pointer"
            onClick={() =>
              (window.location.href = "https://www.englishhome.com.lb/app")
            }
          />
        )} */}

      <div className="overflow-hidden w-full">
        {WidgetsList}

        {ProductsList}

        {isLoading && <PointsLoader />}
      </div>
    </div>
  );
}

export default Home;
